import * as React from 'react';
import $i18n from 'panda-i18n';
import { CnButton } from '@/components/cn-button';
import locale from '@/locale';
$i18n.init({ locale, componentName: 'CnReset' });
export const CnReset = ({ forceClear, validate, onResetValidateFailed, onResetValidateSuccess, form, ...props }) => {
    return (React.createElement(CnButton, { ...props, onClick: (e) => {
            if (props.onClick) {
                if (props.onClick(e) === false)
                    return;
            }
            form
                .reset('*', {
                forceClear,
                validate,
            })
                .then(onResetValidateSuccess)
                .catch(onResetValidateFailed);
        } }, props.children || $i18n.get({ id: 'Reset', dm: '重置', ns: 'CnReset' })));
};
